var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "animated fadeIn" }, [
    !_vm.user.id
      ? _c("div", [
          _c("p", [
            _vm._v(
              "User not found, or you do not have access to this user in the given Org/Group context."
            )
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.user.id
      ? _c(
          "div",
          { staticClass: "personPage" },
          [
            _c(
              "b-row",
              { staticClass: "mb-3", attrs: { "align-h": "between" } },
              [
                _c("b-col", { attrs: { cols: "auto" } }, [
                  _c("h4", { staticClass: "card-title mb-0" }, [
                    _vm._v(_vm._s(_vm.user.fullName))
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "small text-muted" }, [
                    _vm._v("Added " + _vm._s(_vm.getCreatedAt()))
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "b-col",
                  { attrs: { cols: "auto" } },
                  [
                    _c(
                      "router-link",
                      {
                        attrs: { to: "/admin/users/" + _vm.user.id + "/edit" }
                      },
                      [
                        _c("b-button", { staticClass: "mx-0" }, [
                          _vm._v("Edit")
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              [
                _c("b-col", { attrs: { sm: "8" } }, [
                  _c(
                    "div",
                    [
                      _c(
                        "b-card",
                        { attrs: { "no-body": "" } },
                        [
                          _c("b-card-header", [
                            _c("strong", [_vm._v("Information")]),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass:
                                  "switch switch-lg switch-text switch-pill switch-primary-outline-alt pull-right mb-0 wide-toggle"
                              },
                              [
                                _c("input", {
                                  staticClass: "switch-input",
                                  attrs: {
                                    id: "positive_switch",
                                    type: "checkbox"
                                  },
                                  domProps: {
                                    checked: _vm.user.isCseitTrained
                                  },
                                  on: { change: _vm.toggleIsCseitTrained }
                                }),
                                _vm._v(" "),
                                _c("span", {
                                  staticClass: "switch-label",
                                  attrs: {
                                    "data-on": "CSE-IT Trained",
                                    "data-off": "Not CSE-IT Trained"
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "switch-handle" })
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-card-body",
                            [
                              _c("div", { staticClass: "pb-4" }, [
                                _c(
                                  "small",
                                  {
                                    staticClass:
                                      "mb-0 text-muted text-uppercase font-weight-bold"
                                  },
                                  [_vm._v("ID")]
                                ),
                                _vm._v(" "),
                                _c("br"),
                                _vm._v(" "),
                                _c("h4", [_vm._v(_vm._s(_vm.user.id))])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "pb-4" }, [
                                _c(
                                  "small",
                                  {
                                    staticClass:
                                      "mb-0 text-muted text-uppercase font-weight-bold"
                                  },
                                  [_vm._v("Name")]
                                ),
                                _vm._v(" "),
                                _c("br"),
                                _vm._v(" "),
                                _c("h4", [_vm._v(_vm._s(_vm.user.fullName))])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "pb-4" }, [
                                _c(
                                  "small",
                                  {
                                    staticClass:
                                      "mb-0 text-muted text-uppercase font-weight-bold"
                                  },
                                  [_vm._v("Email")]
                                ),
                                _vm._v(" "),
                                _c("br"),
                                _vm._v(" "),
                                _c("h4", [
                                  _vm._v(_vm._s(_vm.user.emailAddress))
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "pb-4" }, [
                                _c(
                                  "small",
                                  {
                                    staticClass:
                                      "mb-0 text-muted text-uppercase font-weight-bold"
                                  },
                                  [_vm._v("Primary Organization")]
                                ),
                                _vm._v(" "),
                                _c("br"),
                                _vm._v(" "),
                                _c("h4", [
                                  _vm._v(
                                    _vm._s(_vm.user.primaryOrganization.title)
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "pb-4" }, [
                                _c(
                                  "small",
                                  {
                                    staticClass:
                                      "mb-0 text-muted text-uppercase font-weight-bold"
                                  },
                                  [_vm._v("Accepted End User Agreement")]
                                ),
                                _vm._v(" "),
                                _c("br"),
                                _vm._v(" "),
                                _c("h4", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.user.acceptedEUA > 0
                                        ? "true"
                                        : "false"
                                    )
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "pb-4" }, [
                                _c(
                                  "small",
                                  {
                                    staticClass:
                                      "mb-0 text-muted text-uppercase font-weight-bold"
                                  },
                                  [_vm._v("Active")]
                                ),
                                _vm._v(" "),
                                _c("br"),
                                _vm._v(" "),
                                _c("h4", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.user.isRemoved
                                        ? "Deactivated"
                                        : _vm.user.active
                                    )
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "pb-4" }, [
                                _c(
                                  "small",
                                  {
                                    staticClass:
                                      "mb-0 text-muted text-uppercase font-weight-bold"
                                  },
                                  [_vm._v("Super Administrator")]
                                ),
                                _vm._v(" "),
                                _c("br"),
                                _vm._v(" "),
                                _c("h4", [
                                  _vm._v(_vm._s(_vm.user.isSuperAdmin))
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _c(
                                  "small",
                                  {
                                    staticClass:
                                      "mb-0 text-muted text-uppercase font-weight-bold"
                                  },
                                  [_vm._v("Welcome Email Sent:")]
                                ),
                                _vm._v(" "),
                                _c("br"),
                                _vm._v(" "),
                                _vm.user.lastWelcomeEmail
                                  ? _c("h4", [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(_vm.getWelcomeDate()) +
                                          "\n                "
                                      )
                                    ])
                                  : _vm._e()
                              ]),
                              _vm._v(" "),
                              _c("br"),
                              _vm._v(" "),
                              _c("br"),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    [
                                      _c(
                                        "b-button",
                                        {
                                          attrs: {
                                            type: "submit",
                                            variant: "primary"
                                          },
                                          on: {
                                            click: function($event) {
                                              $event.preventDefault()
                                              return _vm.sendWelcomeEmail.apply(
                                                null,
                                                arguments
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("Send Welcome Email")]
                                      ),
                                      _vm._v(" "),
                                      _c("br"),
                                      _vm._v(" "),
                                      _c("br"),
                                      _vm._v(" "),
                                      _c(
                                        "b-button",
                                        {
                                          attrs: {
                                            type: "submit",
                                            variant: "primary"
                                          },
                                          on: {
                                            click: function($event) {
                                              $event.preventDefault()
                                              return _vm.sendPasswordResetEmail.apply(
                                                null,
                                                arguments
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("Send Password Reset Email")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    [
                                      _c(
                                        "h2",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.emailSentInProcess,
                                              expression: "emailSentInProcess"
                                            }
                                          ],
                                          staticClass: "u-padding-bottom-20"
                                        },
                                        [
                                          _vm._v(
                                            "Sending Email, please wait ..."
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("pulse-loader", {
                                        attrs: {
                                          loading: _vm.emailSentInProcess,
                                          color: "#0F347B",
                                          size: "50px"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    [
                                      _c("br"),
                                      _vm._v(" "),
                                      _c(
                                        "b-alert",
                                        {
                                          attrs: {
                                            fade: "",
                                            show:
                                              this.emailSentFailure ||
                                              this.emailSentSuccess,
                                            variant: _vm.emailSentFailure
                                              ? "danger"
                                              : "success"
                                          }
                                        },
                                        [
                                          _c("span", {
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.apiResponseMessage()
                                              )
                                            }
                                          })
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c(
                  "b-col",
                  { attrs: { sm: "4" } },
                  [
                    !_vm.user.active || _vm.user.isRemoved
                      ? _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              { attrs: { sm: "12" } },
                              [
                                _c(
                                  "b-card",
                                  { attrs: { "bg-variant": "danger" } },
                                  [
                                    _c("div", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.user.isRemoved
                                              ? "This user is deactivated"
                                              : "This user is inactive"
                                          ) +
                                          "\n              "
                                      )
                                    ])
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          { attrs: { sm: "12" } },
                          [
                            _c("UserMemberships", {
                              attrs: { user: _vm.user, userId: _vm.userId }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          { attrs: { sm: "12" } },
                          [
                            _c(
                              "b-card",
                              { attrs: { "no-body": "" } },
                              [
                                _c("b-card-header", [
                                  _c("b", [_vm._v("Meta")])
                                ]),
                                _vm._v(" "),
                                _c(
                                  "b-list-group",
                                  { attrs: { flush: "" } },
                                  [
                                    _c(
                                      "b-list-group-item",
                                      { staticClass: "small text-muted" },
                                      [
                                        _c("b", [_vm._v("Created At: ")]),
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.getCreatedAt()) +
                                            "\n                  "
                                        ),
                                        _vm._.isObject(_vm.user.createdBy)
                                          ? _c("div", [
                                              _c("b", [_vm._v(" by: ")]),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm._.get(
                                                      _vm.user,
                                                      "createdBy.emailAddress",
                                                      ""
                                                    )
                                                  ) +
                                                  "\n                  "
                                              )
                                            ])
                                          : _vm._e()
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-list-group-item",
                                      { staticClass: "small text-muted" },
                                      [
                                        _c("b", [_vm._v("Last Updated: ")]),
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.getLastUpdateDate()) +
                                            "\n                  "
                                        ),
                                        _vm._.isObject(_vm.user.updatedBy)
                                          ? _c("div", [
                                              _c("b", [_vm._v(" by: ")]),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm._.get(
                                                      _vm.user,
                                                      "updatedBy.emailAddress",
                                                      ""
                                                    )
                                                  ) +
                                                  "\n                  "
                                              )
                                            ])
                                          : _vm._e()
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7b43009a", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b43009a","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/t1/Admin/User.vue
// module id = 1832
// module chunks = 0